const DomainOperaionScreen = () => {

    return(
        <p>Domain Operation</p>
    )
}

export default DomainOperaionScreen